import { GraduationCap, Zap, Headphones, Sparkles, BarChart3, Rocket } from "lucide-react";

export type ServiceLink = {
  icon: typeof GraduationCap;
  name: string;
  href: string;
  description: string;
  features: string[];
  ctaText?: string;
  group?: "entry" | "onboarding" | "services";
};

// "Services" — Dynamics 365 sub-brand offerings surfaced in the Header dropdown and Home page grid.
export const services: ServiceLink[] = [
  {
    icon: GraduationCap,
    name: "Customer Care",
    href: "/customer-care",
    description: "Open to any Dynamics 365 user. One free hour of support every month, best-in-the-world pricing on D365 licenses, plus free content and how-tos.",
    features: ["1 free hour of D365 support every month", "Best-in-the-world pricing on D365 licenses", "Free how-tos, guides & content", "Open to any D365 user"],
    group: "entry",
  },
  {
    icon: Zap,
    name: "D365 Add-Ons",
    href: "/add-ons",
    description: "Free and paid add-ons that put your Dynamics 365 on steroids — built and supported by UniverseIT.",
    features: ["D365 SuperEmail (free) — email on your CRM/BC data", "D365 SuperImport — bulk import & update (coming soon)", "Built and supported by UniverseIT"],
    group: "services",
  },
  {
    icon: Headphones,
    name: "D365 Help Desk",
    href: "/help-desk",
    description: "Open to the public. Immediate Dynamics 365 support — agree to our hourly billing terms and drop a $1 card hold to get started.",
    features: ["Open to everyone — no contract", "Immediate, on-demand D365 support", "Simple hourly billing", "CRM and Business Central support"],
    group: "services",
  },
  {
    icon: Sparkles,
    name: "D365 Client Success — CRM",
    href: "/customer-success-crm",
    description: "A dedicated D365 resource to implement, maintain and support your Dynamics 365 CRM — Sales, Customer Service and Marketing.",
    features: ["Dedicated D365 CRM resource", "Implementation or ongoing maintenance & support", "Sales, Customer Service & Marketing", "Dashboards, workflows & automations"],
    group: "services",
  },
  {
    icon: BarChart3,
    name: "D365 Client Success — Business Central",
    href: "/customer-success-business-central",
    description: "A dedicated D365 resource to implement, maintain and support your Dynamics 365 Business Central — finance, operations and inventory.",
    features: ["Dedicated Business Central resource", "Implementation or ongoing maintenance & support", "Finance, operations & inventory", "Reporting, integrations & automations"],
    group: "services",
  },
  {
    icon: Rocket,
    name: "D365 Implementations",
    href: "/implementations",
    description: "Best-in-class tools and certified consultants to implement Dynamics 365 CRM and ERP — from SMB to mid-market to enterprise.",
    features: ["SMB, mid-market and enterprise", "CRM and ERP (Business Central) implementations", "Best-in-class implementation tooling", "Scoping, migration, go-live & hypercare"],
    group: "services",
  },
];
